<template>
  <div id="profile">
    <h1 class="mt-4">Profile</h1>
    <br />
    <b-container>
      <b-table stacked :fields="fields_user" :items="userinfo" outlined>
      </b-table>
    </b-container>
    <b-container>
      <b-table stacked :items="attribute_value" outlined>
      </b-table>
    </b-container>
  </div>
</template>

<script>
export default {
  created() {
    this.access_token = localStorage.getItem("access_token");
    this.$http
      .get(this.api_user, {
        headers: {
          Authorization: "Bearer " + this.access_token,
        },
      })
      .then((response) => {
        this.userinfo = [response.data];
      });

    
    this.$http
      .get(this.api_attribute_value, {
        headers: {
          Authorization: "Bearer " + this.access_token,
        },
      })
      .then((response) => {
        let obj = {}
        for(let attr of response.data){
          this.attribute.push(attr.key)
          obj[attr.key] = attr.value
        }
        this.attribute_value = [obj]
        //console.log(this.attribute_value)
      });
  },
  data() {
    return {
      fields_user: [
        {
          key: "username",
          label: "User Name",
        },
        {
          key: "email",
          label: "E-Mail",
        },
      ],
      userinfo: [],
      access_token: "",
      attribute: [],
      attribute_value: [],
      api_user: "/user/me",
      api_attribute: "/attribute",
      api_attribute_value: "attribute/value/me",
    };
  },
};
</script>